import React from 'react';
import { Popover, Paper, Typography, Button, Stack, Box } from '@mui/material';

interface RemoveSiteConfirmPopoverProps {
  anchorEl: HTMLElement | null;
  siteName: string;
  onClose: () => void;
  onConfirm: () => void;
  isRemoving?: boolean;
}

export const RemoveSiteConfirmPopover: React.FC<
  RemoveSiteConfirmPopoverProps
> = ({ anchorEl, siteName, onClose, onConfirm, isRemoving = false }) => {
  const open = Boolean(anchorEl);

  const handleConfirm = () => {
    onConfirm();
    // Don't close here - parent will close after mutation completes
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={isRemoving ? undefined : onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      slotProps={{
        paper: {
          sx: {
            mt: 1,
            minWidth: 280,
            maxWidth: 320,
          },
        },
      }}
      data-testid="remove-site-confirm-popover"
    >
      <Paper sx={{ p: 2 }}>
        <Stack spacing={2}>
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              Remove site access?
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Remove <strong>{siteName}</strong> from this user?
            </Typography>
          </Box>

          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button
              size="small"
              onClick={onClose}
              disabled={isRemoving}
              data-testid="cancel-remove-button"
            >
              Cancel
            </Button>
            <Button
              size="small"
              variant="contained"
              color="error"
              onClick={handleConfirm}
              disabled={isRemoving}
              data-testid="confirm-remove-button"
            >
              {isRemoving ? 'Removing...' : 'Remove'}
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Popover>
  );
};
